import { ReactNode } from "react";
import styled from "styled-components";

export default function Warning({ warningMessage }: { warningMessage: string | ReactNode }) {
	return <WarningWrapper>{warningMessage}</WarningWrapper>;
}

const WarningWrapper = styled.div`
	padding: 12px 24px;
	box-sizing: border-box;
	background-color: var(--varsel-lys-gul);
	color: #000000;
	font-weight: 500;
`;
